import { useState, useCallback, useEffect } from 'react';
import { billApi } from '@api';
import { IOrderBillDetail } from '@root/types/bill';
import { useParams } from 'react-router-dom';

const useBillDetail = (): {
  detail: IOrderBillDetail;
  loading: number;
  getDetail: () => void;
} => {
  const [loading, setLoading] = useState(-1);
  const { id } = useParams();
  const [detail, setDetail] = useState<IOrderBillDetail>(
    {} as IOrderBillDetail,
  );

  const getDetail = useCallback(() => {
    if (!id) {
      return;
    }

    setLoading(0);

    billApi
      .getOrderDetail(id)
      .then((data: any) => {
        setDetail(data || {});
        setLoading(1);
      })
      .catch(() => {
        setLoading(2);
      });
  }, [id]);

  useEffect(() => {
    getDetail();
  }, [getDetail]);

  return {
    detail,
    loading,
    getDetail,
  };
};

export default useBillDetail;
